import axios, { AxiosError } from "axios";
import { HeritageDto, PersonDto } from "../components/tree/TreeTypes";
import { API_URL } from "../Constants";
import { UserStorage } from "../store/auth/authSlice";
import { InviteDto, PersonFormValues, HeritageFromValues } from "../types/PersonTypes";
import { formatDate } from "../util/DateUtil";
import { dropboxRedirectUri } from "../pages/Files";

export const getUserProfile = async (username: string) => {
  let resp = await axios
    .get(API_URL + "/graph/person/username/" + username)
    .catch((error: AxiosError) => {
      return error.response;
    });

  if (resp?.status !== 200) {
    console.error(resp);
    return;
    // throw new Error(resp?.statusText)
  }

  console.log(resp);
  return resp?.data as PersonDto;
};

export const getPersonFromInvite = async (inviteId: string) => {
  let resp = await axios
    .get(API_URL + "/graph/public/invitation", {
      params: { inviteId },
      headers: { Authorization: null },
    })
    .catch((error: AxiosError) => {
      return error.response;
    });

  if (resp?.status !== 200) {
    console.error(resp);
    return;
    // throw new Error(resp?.statusText)
  }

  console.log(resp);
  return resp?.data as PersonDto;
};

export const invitePerson = async (personId: string, email?: string) => {
  let resp = await axios
    .put(API_URL + "/graph/user/invite", null, { params: { personId } })
    .catch((error: AxiosError) => {
      return error.response;
    });

  if (resp?.status !== 200) {
    console.error(resp);
    return;
    // throw new Error(resp?.statusText)
  }

  console.log(resp);
  return resp?.data as InviteDto;
};

export const saveDropboxCode = async (code: string, personId: string) => {
  let resp = await axios
    .put(API_URL + "/graph/person/dropbox/code", null, {
      params: {
        code,
        personId,
        redirectUri: dropboxRedirectUri,
      },
    })
    .catch((err: AxiosError) => {
      console.error(err);
      return err.response;
    });
  return resp?.status === 200;
};

export const sendHelpForm = async (values: any, captchaToken: string) => {
  let resp = await axios
    .post(API_URL + "/graph/public/help/", values, {
      params: {
        captchaToken,
      },
    })
    .catch((err: AxiosError) => {
      console.error(err);
      return err.response;
    });
  return resp?.status === 200;
};

export const sendFriendRequest = async (source: string, target: string) => {
  let resp = await axios
    .post(API_URL + "/graph/friendship/friendRequest", null, {
      params: {
        source,
        target,
      },
    })
    .catch((err: AxiosError) => {
      console.error(err);
      return err.response;
    });

  console.log(resp);
  return resp?.status === 200;
};

export const findMatchingProfiles = async (
  values: PersonFormValues,
  onlyUsers = false,
  skip = 0,
  limit = 20
) => {
  let resp = await axios
    .post(
      API_URL + "/graph/persons/find",
      {
        name: values.name,
        surname: values.surname,
        birthDay: formatDate(values.day, values.month, values.year),
        cityOfBirth: values.city,
        countryOfBirth: values.country,
      },
      {
        params: {
          onlyUsers,
        },
      }
    )
    .catch((err) => {
      console.error(err);
      return err;
    });

  console.log(resp);
  if (resp && resp.data && (resp.data as PersonDto[]))
    return resp.data as PersonDto[];
};

export const getUserProfileById = async (id: string) => {
  let resp = await axios
    .get(API_URL + "/graph/person/" + id)
    .catch((error: AxiosError) => {
      return error.response;
    });

  if (resp?.status !== 200) {
    console.error(resp);
    //throw new Error(resp?.statusText)
  }

  console.log(resp);
  return resp?.data as PersonDto;
};

export const getUsersProfiles = async (ids: string[]): Promise<PersonDto[]> => {
  return await Promise.all(ids.map((id) => getUserProfileById(id)));
};

export const getUsedStorage = async (
  userId: string
): Promise<UserStorage | undefined> => {
  let resp = await axios
    .get(API_URL + "/graph/usedStorage", { params: { userId } })
    .catch((error: AxiosError) => {
      return error.response;
    });

  if (resp?.status !== 200) {
    console.error(resp);
    //throw new Error(resp?.statusText)
  }

  return resp?.data as UserStorage;
};

export const getHeritage = async (personId: string) => {
  let resp = await axios
    .get(API_URL + "/graph/person/getHeritage", {
      params: { personId },
    })
    .catch((error: AxiosError) => {
      return error.response;

    });
  if (resp?.status !== 200) {
    console.error(resp);
    return;
  }

  return resp.data as HeritageDto;
};

export const getHeritageById = async (heritageId: string): Promise<HeritageDto | undefined> => {
  try {
    let resp = await axios
      .get(API_URL + "/graph/person/getHeritageById", {
        params: { heritageId },
      });

    if (resp.status !== 200) {
      console.error(resp);
      return;
    }

    return resp.data as HeritageDto;
  } catch (error) {
    const err = error as AxiosError;
    console.error("Error al obtener heritage por ID:", err?.response || err);
    return;
  }
};

export const findHeritages = async (personId: string): Promise<HeritageDto[] | undefined> => {
  try {
    const resp = await axios.post(API_URL + "/graph/person/findHeritages", null, {
      params: { personId },
    });
    if (resp.status !== 200) {
      console.error(resp);
      return;
    }
    return resp.data as HeritageDto[];
  } catch (error) {
    const err = error as AxiosError;
    console.error("Error al obtener los heritages por personId:", err?.response || err);
    return;
  }
};

export const createOrUpdateHeritage = async (
  values: HeritageFromValues,
  userId: string
) => {
  let resp = await axios
    .post(
      API_URL + "/graph/person/createOrUpdateHeritage",
      values
      ,
      {
        params: {
          userId,
        },
      }
    )
    .catch((error: AxiosError) => {
      console.error("Error creando o actualizando heritage:", error);
      return error.response;
    });

  if (resp?.status !== 200) {
    console.error("Respuesta del servidor con error:", resp);
  }

  return resp?.data;
};

export const deleteHeritage = async (heritageId: string) => {
  const resp = await axios
    .delete(`${API_URL}/graph/person/deleteHeritage`, {
      params: { heritageId },
    })
    .catch((error: AxiosError) => {
      console.error("Error al eliminar el heritage:", error);
      return error.response;
    });

  if (resp?.status !== 200) {
    console.error("Respuesta del servidor con error al eliminar:", resp);
    return false;
  }

  return true;
};

export const deleteHeir = async (heirId: string) => {
  const resp = await axios
    .delete(`${API_URL}/graph/person/deleteHeir`, {
      params: { heirId },
    })
    .catch((error: AxiosError) => {
      console.error("Error al eliminar el heir:", error);
      return error.response;
    });

  if (resp?.status !== 200) {
    console.error("Respuesta del servidor con error al eliminar:", resp);
    return false;
  }

  return true;
};

export const testHeritageOwnerReminder = async (personId: string): Promise<string> => {
  const resp = await axios
    .post(`${API_URL}/graph/person/heritage/test/ownerReminder`, null, {
      params: { personId },
    })
    .catch((error: AxiosError) => {
      console.error("Error sending owner reminder:", error);
      return error.response;
    });
  if (resp?.status !== 200) {
    throw new Error("Errore nell'invio del reminder al proprietario");
  }
  return resp?.data as string;
};

export const testHeritageHeirNotification = async (personId: string): Promise<string> => {
  const resp = await axios
    .post(`${API_URL}/graph/person/heritage/test/heirNotification`, null, {
      params: { personId },
    })
    .catch((error: AxiosError) => {
      console.error("Error sending heir notification:", error);
      return error.response;
    });
  if (resp?.status !== 200) {
    throw new Error("Errore nell'invio della notifica agli eredi");
  }
  return resp?.data as string;
};

export const getEscalatedHeritages = async (): Promise<HeritageDto[]> => {
  try {
    const resp = await axios.get(`${API_URL}/graph/admin/getEscalatedHeritages`);
    console.log(resp.data)
    return resp.data as HeritageDto[];
  } catch (error) {
    console.error("Error al obtener herencias escaladas:", error);
    return [];
  }
};

export const resendEmail = async (heritage: any, heir: any, email: string, changeStatus: boolean) => {
  
  const params = {
    // Heritage
    // heritageId: heritage.id,
    // personId: heritage.personId,
    // personName: heritage.personName,
    // status: heritage.status,
    // allFiles: heritage.allFiles,
    // downTime: heritage.downTime,

    // Heir
    heirId: heir.id,
    heirName: heir.name,
    heirSurname: heir.surname,
    heirEmail: email,
    heirAddress: heir.address,
    heirPhoneNumber: heir.phoneNumber,
    heirEmailReceived: heir.emailReceived,

    changeStatus: changeStatus
  };

  try {
    const response = await axios.post(`${API_URL}/graph/person/sendEmail`, heritage, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error al reenviar el correo:", error);
    throw error;
  }
};

